export const convertRTCStatsToVQSStats = (webRTCStats, logger) => {
    const remoteVideoStats = webRTCStats.remoteVideoTrackStats?.length > 0
        ? webRTCStats.remoteVideoTrackStats[0]
        : undefined;
    const localVideoStats = webRTCStats.localVideoTrackStats?.length > 0
        ? webRTCStats.localVideoTrackStats[0]
        : undefined;
    if (!remoteVideoStats) {
        logger.debug('no remote video stats');
        return null;
    }
    if (!localVideoStats) {
        logger.debug('no local video stats');
        return null;
    }
    return {
        frameRate: remoteVideoStats.frameRate ?? 0,
        codec: remoteVideoStats.codec,
        roundTripTime: localVideoStats.roundTripTime ?? 0,
        bitRate: remoteVideoStats.bitRate ?? 0,
        height: remoteVideoStats.dimensions?.height ?? 0,
        width: remoteVideoStats.dimensions?.width ?? 0,
        jitterBufferDelay: remoteVideoStats.jitterBufferDelay ?? 0,
    };
};
//# sourceMappingURL=remote_video_quality_utils.js.map